import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, Button, TS_ComponentTransition } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_CssTransitions.scss';
class PgDev_CssTransitions_Class extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return {
            showTransitionItem: false,
        };
    }
    toggleShowTransitionItem = () => {
        this.setState({ showTransitionItem: !this.state.showTransitionItem });
    };
    render() {
        return _jsxs("div", { className: 'pg-dev-css-transitions', children: [_jsx(Button, { onClick: this.toggleShowTransitionItem, children: "Toggle Show Transition Item" }), _jsx(TS_ComponentTransition, { trigger: this.state.showTransitionItem, mountTimeout: 100, transitionTimeout: 500, unmountTimeout: 100, children: _jsx("div", { className: 'transition-item', children: "Transition Item" }) })] });
    }
}
export const PgDev_CssTransitions = { name: 'CssTransitions', key: 'css-transitions', renderer: PgDev_CssTransitions_Class };
